import { Component, OnInit, Output, HostListener, ViewChild, OnDestroy, AfterViewInit, NgZone } from "@angular/core";
import { NavigationStart, Router, RouterOutlet } from "@angular/router";
import { componentRoutes } from "./route-mapping";
import { PopupContentComponent } from "./popup-content/popup-content.component";
import { ServiceStock } from "./service-stock.service";
import { Platform } from "@ionic/angular";
import { DeviceDetectorService, DeviceType } from "ngx-device-detector";
import { PopupModalComponent } from "./popup-modal/popup-modal.component";
import { ActivityMonitor } from "./activitymonitor.service";
import { FileTransfer } from "@ionic-native/file-transfer/ngx";
import { UXDimensions, UXUtils } from "./utils/ux";
import { FcmNotificationService } from "./fcm-notification.service";
import { ObservableService } from "./observable.service";
import { filter, map, Observable } from "rxjs";
import { SpinnerService } from './services/spinner/spinner.service';
import { CommonService } from "./common.service";
import { Directionality } from "@angular/cdk/bidi";
import { HttpClient } from "@angular/common/http";
import { PreLoginService } from "./pre-login/pre-login.service";
import { UserService } from "./user.service";
import { MatDialog, MatDialogRef } from "@angular/material/dialog";
import { CBXDialogData } from "./fpx-core/services/dialog/dialog.service";
import { AlertDialogComponent } from "./fpx-core/dialogs/alert-dialog/alert-dialog.component";
import { TranslateService } from "@ngx-translate/core";
import { ConfirmationDialogComponent } from "./fpx-core/dialogs/confirmation-dialog/confirmation-dialog.component";
import { ErrorAlertComponent } from "./rcob/error-alert/error-alert.component";
import { ProcessShellService } from "./process-shell/services/process-shell.service";
import { ShellService } from "./shell/shell.service";
import { ProvidehttpService } from "./providehttp.service";

declare let window: any;
declare let $: any;

const successCallback = (result) => {
  console.log(result); // true - enabled, false - disabled
};

const errorCallback = (error) => {
  console.log(error);
};

@Component({
  selector: "app-root",
  templateUrl: "./app.component.html",
  styleUrls: ["./app.component.scss"],
})
export class AppComponent implements OnInit, AfterViewInit, OnDestroy {
  //@ViewChild("appAlerts") appAlerts: AlertsComponent;

  greenifyExceed$: Observable<any>

  loaderTemplate: string = '<img width="60px" src="./assets/images/spinner.gif" />';
  isMobile: boolean = false;
  showResumeWarning: boolean = false;

  public loading$: Observable<boolean> = this.loadingSpinner.loading$;

  documentDirection: string = 'ltr';

  constructor(
    public loadingSpinner: SpinnerService,
    public services: ServiceStock,
    private router: Router,
    private platform: Platform,
    private deviceService: DeviceDetectorService,
    private activityMonitor: ActivityMonitor,
    private fcmService: FcmNotificationService,
    public observableService: ObservableService,
    protected _commonService: CommonService,
    private dir: Directionality,
    private httpClient: HttpClient,
    private _preLoginService: PreLoginService,
    private _userService: UserService,
    private _dialog: MatDialog,
    protected translate: TranslateService,
    public _processShellService:ProcessShellService,
    private zone: NgZone,
    protected _shellService: ShellService,
    public PhttpService:ProvidehttpService
    ) {

      router.events.subscribe(val => {
        if(this._commonService.isDesktop()){
          history.pushState(null, '', location.href);
        }
        window.onpopstate = function () {
          history.go(1);
        };
      });

    this._commonService.isRtl = dir.value === 'rtl';
    dir.change.subscribe((direction) => {
      this._commonService.isRtl = direction === 'rtl';
      this.documentDirection = (this._commonService.isRtl) ? 'rtl' : 'ltr';
    });

    window["mainScope"] = this.services;
    window.addEventListener("onlogout", this.onLogout, false);
    // window.addEventListener("onPromptIdleTimeout", this.onPromptIdleTimeout, false);
    // window.addEventListener("onSessionTimeout", this.onSessionTimeout.bind(this), false);
    window.addEventListener("startSession", this.startSession.bind(this), false);
    window.addEventListener("resumeLastAction", this.onResumeLastAction.bind(this), false);

    this.isMobile = this.deviceService.isMobile();

    for (var i = 0; i < componentRoutes.length; i++) {
      let route = componentRoutes[i];
      let path = route.path;
      let loadChildren = route.loadChildren;

      for (var j = 1; j < 3; j++) {
        let pushValue = {};
        pushValue["path"] = path;
        pushValue["outlet"] = "popUp" + j;
        pushValue["component"] = PopupContentComponent;
        pushValue["children"] = [
          {
            path: "popup",
            loadChildren: loadChildren,
          },
        ];
        this.router.config.unshift(pushValue);
      }
    }
    let lang = localStorage.getItem('lang') || "En";
    this._commonService.switchLanguage(lang);
    this.services.http.currentLanguage = lang;
  }

  private _screenReload() {
    if(this._commonService.getApplicationMode() != "RM") {
      // Redirecting microsite users to application status screen when hard refresh the browser
      this.router.events.pipe(filter((ev) => ev instanceof NavigationStart)).subscribe((event: NavigationStart) => {
        if(!this.router.navigated && !(event.url.indexOf('/launcher?action') >= 0 || event.url.indexOf('/applicant-info') >= 0 || event.url.indexOf('/suppl-card-req') >= 0 || event.url.indexOf('/application-status') >= 0)) {
          window.open(window.location.origin + window.location.pathname + '#/launcher?action=application-status',"_self");
        }
      });
    }
  }
  //tfacompletedValue : any;

  ngOnInit() {
    this.addGA();
    this._commonService.getErrorMessage('En');
    this._screenReload();
    this._commonService.deviceInfo = this._commonService.getDeviceDetails();

    this.services.initializeUIClass();
    this._commonService.initializeUIClass();
    this.greenifyExceed$ = this.observableService.getExceedPopUp()
    this._commonService.screenWidth = window.innerWidth;
    this._commonService.screenHeight = window.innerHeight;
    //document.getElementById("pageBody").style.height = this._commonService.screenHeight+'px';
    if (this.services.isDesktop()) {
      $('html').addClass('desktop');
      $('html').attr('id', 'desktop');
      UXDimensions.DEVICE_WIDTH = 1280.0;
      UXDimensions.DEVICE_HEIGHT = 800.0;
      UXDimensions.SCREEN_WIDTH = window.innerWidth;
      UXDimensions.SCREEN_HEIGHT = window.innerHeight;
    } else {
      UXDimensions.DEVICE_WIDTH = 375.0;
      UXDimensions.DEVICE_HEIGHT = 812.0;
      console.log("PLATFORM: ", this.platform);
      if (this.platform.is('android')) {
        $('html').attr('id', 'android');
      }
    }

    document.addEventListener("resume", () => {
      if (window.plugins && window.plugins.preventscreenshot) {
        window.plugins.preventscreenshot.enable(successCallback, errorCallback);
      }

      this.activityMonitor.checkAndLogout();
    },
      false
    );
    document.addEventListener("pause", () => {
      if (window.plugins && window.plugins.preventscreenshot) {
        window.plugins.preventscreenshot.disable(successCallback, errorCallback);
      }
    },
      false
    );
    this.services.alert.checkForAlerts.subscribe((data) => {
   //   this.appAlerts.showAlert(data["alertType"], data["alertMsg"], data["timeout"]);
    });
    //trigger push notification listener
    this.fcmService.checkFCMPermission();
  }

  closeExceedPopUp() {
    this.observableService.setExceedPopUp(null)
  }

  ngAfterViewInit() { }


  ngOnDestroy() {
    this.activityMonitor.stopMonitor();
    console.log("Destroyed");
  }

  @HostListener("window:beforeunload", ["$event"])
  beforeunloadHandler(event) {
    if (this.services.http.tfaapplet != undefined && this.services.http.tfaapplet != null) {
      (window as any).logoutFromSmartCard(this.services.http.tfaapplet);
    }
  }

  onLogout() {
    var services = window["mainScope"];
    let inputMap = new Map();
    inputMap.clear();
    inputMap.set("dynamicSubText", "Are you sure you want to logout?");
    inputMap.set("primaryBtnLable", "Yes");
    inputMap.set("secondaryBtnLable", "No");
    inputMap.set("component", "LogOutPopUp");
    const modalRef = services.modal.open(PopupModalComponent, { windowClass: "modal-width-sm" });
    var onModalClose = async (reason) => {
      reason == 0 || reason == 1 ? await services.routing.removeOutlet() : undefined;
      if (services.dataStore.getData("doLogOut")) {
        services.forceLogout();
      }
    };
    modalRef.result.then(onModalClose, onModalClose);
    modalRef.componentInstance.rotueToComponent(inputMap);
    services.dataStore.setModalReference(services.routing.currModal, modalRef);
  }

  // async onPromptIdleTimeout() {
  //   var services = window["mainScope"];
  //   let inputMap = new Map();
  //   inputMap.clear();
  //   for (var i = services.routing.currModal; i > 0; i--) {
  //     await services.dataStore.getModalReference(i).componentInstance.closeModal();
  //   }
  //   inputMap.set("component", "idleSessionTimeout");
  //   const modalRef = services.modal.open(PopupModalComponent, { windowClass: "modal-width-sm" });
  //   var onModalClose = async (reason) => {
  //     reason == 0 || reason == 1 ? await services.routing.removeOutlet() : undefined;
  //     if (services.dataStore.getData("forceLogout")) {
  //       services.http.clearTimer();
  //       services.forceLogout();
  //     } else if (services.dataStore.getData("keepSessionAlive")) {
  //       services.getUserImage(null);
  //       services.dataStore.removeData("keepSessionAlive");
  //     }
  //   };
  //   modalRef.result.then(onModalClose, onModalClose);
  //   modalRef.componentInstance.rotueToComponent(inputMap);
  //   services.dataStore.setModalReference(services.routing.currModal, modalRef);
  // }

  async onSessionTimeout() {
    var services = window["mainScope"];
    services.http.sessionValid = false;
    this.activityMonitor.stopMonitor();
    let _data: CBXDialogData;
    if(this._commonService.getApplicationMode()=='RM'){
      _data= {
        icon: 'session-timeout',
        title: 'Session Expired',
        message: 'Your Session has expired. Please Login to Continue working',
        okLabel: 'Login',
      }
    }
    else{
      _data= {
        icon: 'session-expired',
        title: 'Time Out',
        message: 'Your Session has expired. ',
        redirect: 'Click here to Resume Application',
      }
    }
    this._dialog.closeAll();
    let dialogRef: any ;
    if(this._commonService.getApplicationMode()=='RM'){
      this.zone.run(() => {
        dialogRef = this._dialog.open(AlertDialogComponent, {
          data: _data,
          panelClass: ['alert-dialog','alert-modal'],
          backdropClass: 'confirmation-dialog-backdrop',
          hasBackdrop: true
        });
        dialogRef.afterClosed().subscribe(action => {
          this._preLoginService.refreshTokenService?.stop();
          console.log('app');
          this.zone.run(() => {
            this.router.navigate(['login']);
          });
        });
      })
    } else{
      this.zone.run(() => {
        dialogRef = this._dialog.open(ErrorAlertComponent, {
          data: _data,
          panelClass: ['error-alert-dialog', 'timeout-wrapper'],
          backdropClass: 'confirmation-dialog-backdrop',
          hasBackdrop: true
        });
        dialogRef.afterClosed().subscribe(action => {
          this._preLoginService.refreshTokenService?.stop();
          if(action==1)
            window.open(window.location.origin + window.location.pathname + '#/launcher?action=application-status',"_self");
          else
            this._commonService.exitApplication();
        });
      })
    }


    // dialogRef.afterClosed().subscribe(action => {
    //   this._preLoginService.refreshTokenService?.stop();
    //   if (this._commonService.getApplicationMode()=='RM') {
    //     console.log('app');
    //     this.zone.run(() => {
    //       this.router.navigate(['login']);
    //     });
    //   }
    //     else{
    //       if(action==1)
    //         window.open(window.location.origin + window.location.pathname + '#/launcher?action=application-status',"_self");
    //       else
    //         this._commonService.exitApplication();
    //     }
    // });
  }

  startSession() {
    this.services.dataStore.setUserLoggedIn(true);
    this.activityMonitor.startMonitor(
      () => {
        //TODO DISPLAY PROMPT
        //On User Continute Call this.activityMonitor.continueAndMonitor
        // console.log("Display Inactivity Window: " + this._commonService.getApplicationMode());
        setTimeout(() => {
          // if (this.services.isMobile()) {
            if(this._commonService.getApplicationMode()=='RM'){
              let _data: CBXDialogData = {
                icon: 'session-timeout',
                title: this.translate.instant('SESSIONTIMERLOGOUT.title'),
                message: this.translate.instant('SESSIONTIMERLOGOUT.sessionTimer'),
                min:this.translate.instant('SESSIONTIMERLOGOUT.min'),
                okLabel: this.translate.instant('SESSIONTIMERLOGOUT.logout'),
                cancelLabel: this.translate.instant('SESSIONTIMERLOGOUT.continue')
              }
              this.zone.run(() => {
                this._dialog.closeAll();
                let dialogRef = this._dialog.open(ConfirmationDialogComponent, {
                  data: _data,
                  panelClass: ['confirmation-dialog','confirmation-modal'],
                  backdropClass: 'confirmation-dialog-backdrop',
                  hasBackdrop: true
                });

                dialogRef.afterClosed().subscribe(action => {
                  if (action==1) {
                    this.killSession(true);
                  }
                  else if(action==2){
                    this.continueSession();
                  }
                });
              })
            }
            else{
              let _data: CBXDialogData = {
                icon: 'session-expired',
                title: 'Time Out',
                message: 'Your Session will expire in ',
                min:this.translate.instant('SESSIONTIMERLOGOUT.min'),
                redirect: 'Click here to Refresh',
              }
              this.saveSession();
              this._dialog.closeAll();
              let dialogRef =this._dialog.open(ErrorAlertComponent, {
                data: _data,
                panelClass: ['error-alert-dialog', 'timeout-wrapper'],
                backdropClass: 'confirmation-dialog-backdrop',
                hasBackdrop: true
              });

              dialogRef.afterClosed().subscribe(action => {
                if(action==1)
                this.continueSession();
              });
            }
          // }
        });
        this.activityMonitor.updateWarningTime();
      },
      () => {
        // if (this._userService.isLoggedIn() && this._commonService.getApplicationMode()=='RM')
          //TODO DISMISS PROMPT and exit
          this.killSession();
      }
    );

  }
  saveSession(){
    this._processShellService.saveTheStage();
  }

  continueSession() {
    this.activityMonitor.continueSession();
  }
  killSession(isLoggedOut?) {
    isLoggedOut = isLoggedOut || false;
    this._dialog.closeAll();
    this.activityMonitor.stopMonitor();
    if(this._commonService.getApplicationMode()=='RM' && isLoggedOut){
      this._preLoginService.logout();
    } else {
      this._preLoginService.clearSession();
      this._preLoginService.refreshTokenService?.stop();
    }
    // Commented the immediate next line
    if(!isLoggedOut) this.onSessionTimeout();
    // this.activityMonitor.dissmissAndExit();
  }

  onResumeLastAction() {
    // console.log("onResumeLastAction");
    sessionStorage.removeItem('inAccOpeningWay');
    this.showResumeWarning = true;
  }

  gotoAccountOpening() {
    this.showResumeWarning = false;
    this.services.router.navigate(['/home/openAccount']);
  }

  resumeOnboarding() {
    this.showResumeWarning = false;
    sessionStorage.setItem("forceResume", "1");
    this.services.router.navigate(['/home/openAccount']);
  }

  @HostListener('contextmenu', ['$event'])
  onRightClick(event) {
    event.preventDefault();
  }
  switchLanguage(language: string) {
    this._commonService.switchLanguage(language);
  }

  addGA(){
    this.addMeasurementMetrics();
    this.addDataLayer();
    this.addGTMScript();
    this.addGTMNoscript();
  }
  addMeasurementMetrics(){
    const gtagScript = document.createElement('script');
    gtagScript.async = true;
    gtagScript.src = "https://www.googletagmanager.com/gtag/js?id=" + this.PhttpService.getMeasurementId();
    document.head.appendChild(gtagScript);
  }
  addDataLayer(){
    const script = document.createElement('script');
    let code = "window.dataLayer = window.dataLayer || [];";
    code += "function gtag(){dataLayer.push(arguments);}";
    code += "gtag('js', new Date());"
    try {
      script.appendChild(document.createTextNode(code));
      document.head.appendChild(script);
    } catch (e) {
      script.text = code;
      document.head.appendChild(script);
    }
  }
  addGTMScript(){
    const script = document.createElement('script');
    var code = "(function(w,d,s,l,i){w[l]=w[l]||[];w[l].push({'gtm.start':";
    code += "new Date().getTime(),event:'gtm.js'});var f=d.getElementsByTagName(s)[0],";
    code += "j=d.createElement(s),dl=l!='dataLayer'?'&l='+l:'';j.async=true;j.src=";
    code += "'https://www.googletagmanager.com/gtm.js?id='+i+dl;f.parentNode.insertBefore(j,f);";
    code += "})(window,document,'script','dataLayer','" + this.PhttpService.getGtagid() + "');";
    try {
      script.appendChild(document.createTextNode(code));
      document.head.appendChild(script);
    } catch (e) {
      script.text = code;
      document.head.appendChild(script);
    }
  }
  addGTMNoscript(){
    const script = document.createElement('noscript');
    script.append("<iframe src='https://www.googletagmanager.com/ns.html?id='" + this.PhttpService.getGtagid() + "' height='0' width='0' style='display:none;visibility:hidden'></iframe>")
    document.body.appendChild(script);
  }


}
